import * as api from "../api";

export default {
	methods : {
    make_link( link ){
      if ( link.substr(0,1)=='/' ) link=link.substr(1);
      return document.site_short_url_lang + link;
    },

	  //use @click="slide_show(work, $event)"
    slide_show(work, event, uris){
      if ( window._GL_works_without_slideshow==='y' ) {
        window.location.href=this.getWorkUrl(work);
        stop_bubble(event);
        return false;
      }

      if ( uris==null ){
        uris=this.$store.getters.wfilter;
        if ( uris==null || uris.length===0 ){
          uris='';
          let works=this.$store.getters.works;
          if ( works!=null ){
            works.forEach( function(o, n){
              if ( uris.length>0 ) uris+=',';
              uris+='work://'+o.work_id;
            } );
          }
        }
      }

      model_slideshow_v8.set_access_hash( $('#app-wrapper').attr('access_hash') );
      model_slideshow_v8.do_show(this, '', 'work://'+work.work_id, uris, '0', '', event);
      stop_bubble(event);
      return false;
    },

		//use <img :src="getWorkSrc(work, 'oy200')" :style="'max-height:200px; max-width:'+getWorkWidth(work, 200)+'px'"/>
		getWorkSrc(work, size = 'oy200') {
			if(work.storage_id==20) {
				return this.getMediaSrc( work.media, size );
			}
			else {
				return window._GL_SITE_URL_CDN+'/res/img/page-bg/texture-01.jpg';
			}
		},

    //получаем из 'work://666' сам объект
    getObject(uri, cl_result){
      if ( uri==null || uri.length==0 ) {
        if ( cl_result!=null ) cl_result('');
        return;
      }

      var url = '/action/vue/uri/resolve';
      api.get(url, {uri: uri}).then(response => {
        if ( cl_result!=null ) cl_result(response.data);
      }).catch(e => {
        if ( cl_result!=null ) cl_result('');
      });
    },

		getMediaSrc(media, size = 'oy200') {
      if ( media==null ) return window._GL_SITE_URL_CDN+'/res/img/page-bg/texture-01.jpg';

			let hasWindow = typeof window !== 'undefined';
			let environment = (hasWindow ? window.devicePixelRatio || 1 : 1);
			if (environment>=1.25) environment=2;
			environment=Math.round(environment);

			let add='';
			if ( environment>1 ) add='@2x';

			let ext=media.data.ext;
			/*let icc=media.data.icc;
			if ( icc!='y' ) icc='n';*/
			if ( window._GL_IS_WEBP_SUPPORT=='1' /*&& icc=='n'*/ && (ext=='jpg' || ext=='jpeg' || ext=='png' || ( ext=='gif' && media.data.is_animated!=1 )) ) ext='webp';

      return window._GL_SITE_URL_CDN+'/res/media/img/' +
        size + '/'+
        media.use_type + '/' +
        media.data.version + '/' +
        media.media_id + add + '.' + ext;
		},

		//RA
		getWorkHeight(work, width) {
			if(work.storage_id==20 && work.media.data.ratio>0) {
				return width/work.media.data.ratio;
			}
			else {
				return width;
			}
		},

		//RA
		getWorkWidth(work, height) {
			if(work.storage_id==20 && work.media.data.ratio>0) {
				return height*work.media.data.ratio;
			}
			else {
				return height;
			}
		},

    getWorkYear(work){
      function romanize (num) {
        if (isNaN(num))
          return NaN;
        var digits = String(+num).split(""),
          key = ["","C","CC","CCC","CD","D","DC","DCC","DCCC","CM",
            "","X","XX","XXX","XL","L","LX","LXX","LXXX","XC",
            "","I","II","III","IV","V","VI","VII","VIII","IX"],
          roman = "",
          i = 3;
        while (i--)
          roman = (key[+digits.pop() + (i * 10)] || "") + roman;
        return Array(+digits.join("") + 1).join("M") + roman;
      }

      let y='';
      if ( work['dt_finish']!=null && work['dt_finish'].length>0 ) {
        let parts = work['dt_finish'].split('/'); // 1/20/2001/00

        let c = parts[1];
        if ( c!=null ){
          y = parts[2];
          if ( y==null ) y=romanize(c);
          else {
            y=parseInt(y).toString();
            let m=parts[3];
            if ( m!=null && m==='00' ) y=(y-1)+this.$t('message.decadaYears');
          }
        }
      }
      return y;
    },

    getWorkClass(work){
      /*if ( work.artist.is_pro=='y' ) return 'c_work_pro';
      else return '';*/
      return '';
    },

		getWorkColorStyle(work) {
			if ( work.colors && work.colors.middle ) return 'background-color:#'+work.colors.middle;
			return '';
		},

		getWorkUrl(work) {
      let access_hash=$('#app-wrapper').attr('access_hash');
      if ( access_hash!=null && access_hash.length==32 && work.privacy=='access' ){
        return '/works/'+access_hash+'/'+work.work_id;
      }

      let res='';

			if((work.artist || work.artists) && window._GL_works_without_artist!=='y') {
				res=this.getArtistWorksUrl(work)+'/'+work.name_hash
			}
			else {
			  res=_GL_SITE_SHORT_URL_LANG+'works/'+work.name_hash;
      }

			return res;
		},

		getWorkUri(work) {
			return work.uri;
		},

		getArtistWorksUrl(work) {
      let res='';

      let artist=work.artist;
      if ( !artist ) artist=work.artists[0]['artist_info'];

			if (artist) {
			  res=this.getArtistUrl(artist)+'/works';
			}

			return res;
		},

		getArtistUrl(artist) {
      let res='';

			if (artist) {
        var is_subdomain=$('#app-wrapper').attr('is_subdomain');

        if (is_subdomain==1) res=_GL_SITE_SHORT_URL_LANG+'works/artist:'+artist.artist_id;
			  else if ( artist.nickname ) res=_GL_SITE_SHORT_URL_LANG+artist.nickname;
				else if ( artist.name_hash ) res=_GL_SITE_SHORT_URL_LANG+'artists/'+artist.name_hash;
        else res=_GL_SITE_SHORT_URL_LANG+'artists/'+artist.artist_id;
			}

			return res;
		},

    getWorkName(work) {
      let res=work.artist.full_name+' "'+work.name+'"';

      if ( work['dt_finish']!=null && work['dt_finish'].length>0 ){
        let parts=work['dt_finish'].split('/'); // 1/20/2001/00
        let c=parseInt(parts[1]);
        let y=parseInt(parts[2]);
        let m=parts[3];
        let d=parseInt(parts[4]);

        /*if (c>0){
          this.date_finish_century=this.date_finish_century_options.find(o => o.value==c);

          if (y>0){
            if ( m=='00' ) y+='x';
            this.date_finish_year=this.date_finish_year_options.find(o => o.value==y);

            if (m>0 && m!='00') {
              this.date_finish_month=this.date_finish_month_options.find(o => o.value==m);
              if (d>0) this.date_finish_day=this.date_finish_day_options.find(o => o.value==d);
            }
          }
        }*/

        if ( c>0 && y>0 ) res+=' '+y;
      }

      return res;
    },

    getWorkPrice(work){
      let result='';

      if ( work.status.sale_status=='sale' ){
        if ( work.status.is_negotiated=='n' ){
          result=this.format_price(work.status.price, work.status.currency);
        }
        else if ( work.status.is_negotiated=='y' ){
          result=this.$t("message.Negotiated");
        }
      }

      return result;
    },

    format_price: function(amount, currency){
      if ( amount==null || amount.length==0 ) return '';
      if ( currency==null || currency.length==0 ) return '';

      let result='';
      if ( currency=='usd' || currency=='USD' ) result+='$ ';
      if ( currency=='euro' || currency=='EURO' || currency=='EUR' ) result+='€ ';
      result+=this.show_price(amount);
      if ( currency=='rur' || currency=='RUR' || currency=='RUB' ) result+=' ₽';
      if ( currency=='uah' ) result+=' ₴';
      return result;
    },

    show_num: function( sum ){
      function format_num(n, c, d, t) {
        var c = isNaN(c = Math.abs(c)) ? 2 : c,
          d = d == undefined ? "." : d,
          t = t == undefined ? "" : t,
          s = n < 0 ? "-" : "",
          i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
          j = (j = i.length) > 3 ? j % 3 : 0;

        var res=s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t)/* + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "")*/;
        if ( c ){
          let dec=Math.abs(n - i).toFixed(c).slice(2);
          if ( 1*dec>0 ){
            if ( dec % 10 === 0 ) dec=Math.floor(dec/10);
            res+=d+dec;
          }
        }

        return res;
      };

      return format_num(1*sum);
    },

    show_price: function( sum ){
      function formatMoney(n, c, d, t) {
        var c = isNaN(c = Math.abs(c)) ? 2 : c,
          d = d == undefined ? "." : d,
          t = t == undefined ? " " : t,
          s = n < 0 ? "-" : "",
          i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
          j = (j = i.length) > 3 ? j % 3 : 0;

        if ( window._GL_CUR_LANG=='EN' ) t=',';

        var res=s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t)/* + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "")*/;
        if ( c ){
          let dec=Math.abs(n - i).toFixed(c).slice(2);
          if ( 1*dec>0 ){
            res+=d+dec;
          }
        }

        return res;
      };

      return formatMoney(1*sum);
    },
	},

	computed : {
		workName() {
			return this.work.name
		},
		workdesc() {
			return this.work.description
		},
		audiotrue(){
			if (this.work.counters.audioguides >0){
				return true
			}else{
				return false
			}
		},
		videotrue(){
			return ( this.work['has_video']==='y' );
		},
		digitaltrue(){
		  if ( this.work['status_digital'] && this.work['status_digital']['sale_status'] ) return ( this.work['status_digital']['sale_status']==='sale' );
		  else return false;
		},
    coords() {
		  if ( this.work.coords==null ) return false;
      return (this.work.coords.lat!=0 || this.work.coords.lon!=0)
    },
    copyright() {
      return (this.work.is_copyright_hidden=='y')
    },
    has_interior() {
      return (this.work.has_interior=='y')
    },
		authorName() {
      return this.work.artist.full_name;
		},

		authorId() {
      return this.work.artist.artist_id;
		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./src/mixins/mixin_work.js
// module id = null
// module chunks = 